import { useState, useEffect } from 'react';
import { API_CONFIG } from '../services/api/endpoints';

/**
 * Fetches whether signups are currently enabled.
 * Uses plain fetch (no auth headers/credentials) since this is a public endpoint.
 * Defaults to false (closed) on error or timeout.
 */
export function useSignupEnabled() {
  const [signupEnabled, setSignupEnabled] = useState<boolean>(false);
  const [paidPlansEnabled, setPaidPlansEnabled] = useState<boolean>(false);

  useEffect(() => {
    let cancelled = false;
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000);

    fetch(`${API_CONFIG.BASE_URL}/admin/system/settings`, { signal: controller.signal })
      .then((res) => res.json())
      .then((data) => {
        clearTimeout(timeoutId);
        if (!cancelled) {
          setSignupEnabled(data?.data?.signupEnabled ?? false);
          setPaidPlansEnabled(data?.data?.paidPlansEnabled ?? false);
        }
      })
      .catch(() => {
        clearTimeout(timeoutId);
        if (!cancelled) {
          setSignupEnabled(false);
          setPaidPlansEnabled(false);
        }
      });

    return () => {
      cancelled = true;
      controller.abort();
    };
  }, []);

  return { signupEnabled, paidPlansEnabled };
}
